import {
    GET_LOCALE_DISPLAY_NAME,
    SET_SPACE_LOCALIZATIONS,
    SET_CURRENT_LOCALE,
    LOAD_SPACE_LOCALIZATIONS,
} from "../services/constants"
import http from "../services/axios"

export const localizationStoreModule = {
    state: {
        spaceLocalizations: null,
        currentLocale: 'default',
        currentLocaleIndex: 0,
        languages: [
            {
                locale: 'default',
                displayName: 'Default',
            },
            {
                locale: 'en',
                displayName: 'English',
            },
            {
                locale: 'he',
                displayName: 'Hebrew',
            },
            {
                locale: 'es',
                displayName: 'Spanish',
            },
            {
                locale: 'fr',
                displayName: 'French',
            },
        ]
    },
    getters: {
        [GET_LOCALE_DISPLAY_NAME]: (state) => (locale) => {
            const foundLanguage = state.languages.find(language => {
                return language.locale === locale
            })
            return foundLanguage ? foundLanguage.displayName : null
        },
    },
    mutations: {
        [SET_SPACE_LOCALIZATIONS]: (state, payload) => {
            state.spaceLocalizations = payload
        },
        [SET_CURRENT_LOCALE]: (state, payload) => {
            if (payload) {
                state.currentLocale = payload
            } else {
                state.currentLocale = 'default'
            }
            if (state.spaceLocalizations) {
                state.currentLocaleIndex = state.spaceLocalizations.findIndex(lang => {
                    return lang === state.currentLocale
                })
            }
        }
    },
    actions: {
        [LOAD_SPACE_LOCALIZATIONS]: (context) => {
            http.get(`api/management/spaces/${context.rootState.spaceMetadata.id}/properties/localization.supported.langs`)
                .then(results => {
                    if (results.status !== 204) {
                        const str = `default,${results.data.value}`
                        const arr = str.split(',')
                        context.commit(SET_SPACE_LOCALIZATIONS, arr);
                        context.commit(SET_CURRENT_LOCALE, context.state.currentLocale);
                    }
                }).catch(err => {
                console.log(err)
            })
        },
    },
}